import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {classMap} from 'lit/directives/class-map.js';
import store from '../../../store';
import {selectIomoDesign} from '../../iomoSelectors';

@customElement('visual-iomo-mounting')
export class VisualIomoMounting extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}

		.container {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: end;
		}

		.mountings {
			width: 50%;
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-template-rows: 1fr 1fr 1fr;
			gap: 20px;
			grid-template-areas:
				"pole ceiling"
				"pole wall"
				"pole floor";
		}

		.mounting {
			opacity: 0.3;
			transition: opacity 0.4s;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}
		.active {
			opacity: 1;
		}

		.pole {
			grid-area: pole;
		}

		.ceiling {
			grid-area: ceiling;
			justify-content: start;
		}

		.wall {
			grid-area: wall;
			align-items: end;
		}

		.floor {
			grid-area: floor;
			justify-content: end;
			padding-bottom: 20px;
		}

		.poleImg {
			height: 80vh;
			width: auto;
		}

		.ceilingImg {
			height: 8vh;
			width: auto;
		}

		.wallImg {
			height: 10vh;
			width: auto;
		}

		.floorImg {
			height: 8vh;
			width: auto;
		}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.design = selectIomoDesign(state);
		console.log(this.design);
	}
	render() {
		const s = this.state;
		return html`
			<div class="container">
				<div class="mountings">
					<div class="mounting pole ${classMap({active: this.design === 'pole'})}">
						<img class="poleImg" src="/line-assets/img/iomo/Iomo_Pole.png" alt="Iomo Pole">
					</div>
					<div class="mounting ceiling ${classMap({active: this.design === 'ceiling'})}">
						<img class="ceilingImg" src="/line-assets/img/iomo/Iomo_Ceiling.png" alt="Iomo Ceiling">
					</div>
					<div class="mounting wall ${classMap({active: this.design === 'wall'})}">
						<img class="wallImg" src="/line-assets/img/iomo/Iomo_Wall.png" alt="Iomo Wall">
					</div>
					<div class="mounting floor ${classMap({active: this.design === 'floor'})}">
						<img class="floorImg" src="/line-assets/img/iomo/Iomo_Floor.png" alt="Iomo Floor">
					</div>
				</div>
			</div>
		`;
	}
}
